import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { USER_INFO } from "../config/apiEndPoint";
import { GET, MULTIPART_PUT } from "config/api.config";

export const fetchUserPermissions = async () => {
  try {
    const response = await GET(USER_INFO.GET_PERMISSIONS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `user-info/profile` — current user profile details. */
export const fetchUserProfile = async () => {
  try {
    const response = await GET(USER_INFO.PROFILE);
    return response;
  } catch (error) {
    toast.error(error?.message || "Unable to load profile");
    return null;
  }
};

/**
 * PUT `user-info/profile` — update profile (`multipart/form-data`).
 * Fields: Name, OldPassword, Password, RePassword, UserImageFile.
 */
export const updateUserProfile = async (formData) => {
  if (!(formData instanceof FormData)) {
    toast.error("Invalid profile payload");
    return null;
  }
  try {
    const response = await MULTIPART_PUT(USER_INFO.PROFILE, formData);
    return response;
  } catch (error) {
    toast.error(error?.message || "Unable to update profile");
    return null;
  }
};
